module.exports = __webpack_public_path__ + "img/bg-green.b30fc221.jpg";